import Vue from 'vue';

import consts from './consts.js';
import ConciergeTel from './member/components/conciergeTel.vue';

var appMixin = {
    components: {
        'concierge-tel': ConciergeTel
    },
    data: function() {
        return {
            consts: consts,
            conciergeTel: '050-5356-2054',
        };
    },
    methods: {
        pushDataLayer: function(obj) {
            window.dataLayer.push(_.extend(obj, {
                'event': 'gourmetplus'
            }));
        },
        backgroundImage: function(url) {
            return 'background-image: url(' + url + ')';
        },
        imageUrl: function(path) {
            return window.data.STATIC_URL + '/images' + path;
        },
        fetchUnreadNotifications: function() {
            this.$root.pollUnreadNotifications();
        },
        areaLabel: function(areaId, shopArea) {
            if (_.isString(areaId)) {
                areaId = Number(areaId);
            }
            var area = _.find(shopArea, function(area) {
                return areaId === area.value;
            }.bind(this));
            if (!area) {
                return '';
            }
            return area.label;
        },
        areaDetailsOf: function(areaId, shopAreaDetail) {
            if (_.isString(areaId)) {
                areaId = Number(areaId);
            }
            return _.filter(shopAreaDetail, function(areaDetail) {
                return areaId === areaDetail.area;
            }.bind(this));
        },
        stationsOfArea: function(areaId, station) {
            if (_.isString(areaId)) {
                areaId = Number(areaId);
            }
            return _.filter(station, function(station) {
                return areaId === station.area;
            }.bind(this));
        },
        stationsOfAreaDetail: function(areaDetailIds, station) {
            if (!_.isArray(areaDetailIds)) {
                areaDetailIds = [areaDetailIds];
            }
            areaDetailIds = areaDetailIds.map(function(areaDetailId) {
                if (_.isString(areaDetailId)) {
                    return Number(areaDetailId);
                }
                return areaDetailId;
            });
            return _.filter(station, function(station) {
                return _.includes(areaDetailIds, station.area_detail);
            }.bind(this));
        },
        selectedShops: function() {
            return JSON.parse(window.localStorage.getItem('selectedShops')) || [];
        },
        setShops: function(shops) {
            window.localStorage.setItem('selectedShops', JSON.stringify(shops || []));
        }
    },
    computed: {
        userId: function() {
            return window.data.uid;
        },
        userRole: function() {
            return window.data.role;
        },
        loginId: function() {
            return window.data.loginId;
        },
        isAdministrator: function() {
            return this.userId === '1';
        }
    }
};
Vue.mixin(appMixin);
